import { FC } from 'react';

const Reports: FC = (): JSX.Element => {
  return <div>Reports component</div>;
};

export default Reports;
